var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4b233;\n        opacity: .33;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #f4b233;\n      }\n\n      .cls-2 {\n        fill: #000;\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 130,
    height: 33,
    rx: 4.5,
    ry: 4.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 0.5,
    width: 130,
    height: 33,
    rx: 4.5,
    ry: 4.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.93,16.6v-4.58h2.33v4.46c0,1.06.66,1.81,1.59,1.81s1.6-.76,1.6-1.81v-4.46h2.33v4.58c0,2.23-1.62,3.8-3.92,3.8s-3.92-1.57-3.92-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.13,12.02h2.33l3.21,4.41v-4.41h2.33v8.24h-2.33l-3.21-4.41v4.41h-2.33v-8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.44,12.02h3.95c1.85,0,3.15,1.19,3.15,2.88s-1.31,2.88-3.15,2.88h-1.62v2.48h-2.33v-8.24ZM64.2,15.66c.55,0,.95-.32.95-.77s-.4-.77-.95-.77h-1.43v1.54h1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.69,19.15h-2.87l-.42,1.1h-2.63l3.17-8.24h2.63l3.17,8.24h-2.63l-.42-1.1ZM73.03,17.44l-.77-2-.78,2h1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.52,12.02h2.33v8.24h-2.33v-8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.32,12.02h3.07c2.88,0,4.92,1.7,4.92,4.11s-2.04,4.13-4.92,4.13h-3.07v-8.24ZM84.78,18.14c1.25,0,2.13-.84,2.13-2.01s-.89-2-2.13-2h-1.13v4.02h1.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpaid);
export default __webpack_public_path__ + "static/media/Unpaid.28c5f9d22f95b158aee7507c438ca289.svg";
export { ForwardRef as ReactComponent };